/**
 * Knowledge Base content loader (#1086, epic #1085).
 *
 * Sources the KB sections from the versioned package at
 * guides/knowledge-base/<version>/en-US.json - the same package the publish
 * pipeline translates + synthesizes (Parts 2/3 of #1085). Loaded from the
 * bundle here; locale-aware S3 loading + per-section audio arrive in Part 3
 * (#1088). Section ids are stable and become the audio-file key.
 */
import kbPackage from '../../../guides/knowledge-base/2026-10-06.01/en-US.json';

export const KB_VERSION = kbPackage.version;
export const KB_MODULE_ID = kbPackage.moduleId;
export const DOCS_SECTIONS = kbPackage.sections;

export default DOCS_SECTIONS;
